import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    image = "image",
    heading = "name",
    backgroundImage = "backgroundImage",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.image]: string;
        [fields.heading]: string;
        [fields.backgroundImage]: string;
    };
}

export interface CENLeadBannerStyles {
    imageWrapper: InjectableCss;
    headingWrapper: InjectableCss;
    heading: InjectableCss;
    img: InjectableCss;
}

export const CENleadBannerStyles: CENLeadBannerStyles = {
    imageWrapper: {
        css: css`
            display: flex;
            justify-content: end;
        `,
    },
    headingWrapper: {
        css: css`
            width: 700px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 65%;
                        align-self: center;
                    `,
                    css`
                        flex-basis: 65%;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    heading: {
        css: css`
            color: ${COLORS.white};
            margin: 63px 26px 0px 64px !important;
            text-align: left;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: ${TYPOGRAPHY.size.base};
                        line-height: ${TYPOGRAPHY.lineHeight.small};
                        margin: 0px 0px 0px 22px !important;
                    `,
                    css`
                        font-size: 34px;
                        line-height: 45px;
                        margin: 50px 10px 0px 30px !important;
                    `,
                    css`
                        font-size: 40px;
                        line-height: 45px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    img: {
        css: css`
            width: 452px;
            height: 400px;
            top: -62px;
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        height: auto;
                        top: 0px;
                        aspect-ratio: 1.68/1;
                    `,
                    css`
                        width: 260px;
                        height: 372px;
                    `,
                    css`
                        width: 375px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
};

const styles = CENleadBannerStyles;

export const CENLeadBannerStyles: FC<OwnProps> = ({ fields }) => {
    const backgroundStyles = fields.backgroundImage
        ? `background: url(${fields.backgroundImage}); background-size: cover; background-repeat: no-repeat; flex-direction:row;flex-wrap:wrap;`
        : `background: linear-gradient(90deg, #266b40 27.08%, #2d804c 71.87%, #43687a 100%); flex-direction:row-reverse;justify-content: space-between;`;
    const bannerWrapper = {
        css: css`
            ${backgroundStyles}
            display: flex;
            height: 337px;
            margin-top: 45px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: 180px;
                        margin-top: 26px;
                    `,
                    css`
                        height: 310px;
                        margin-top: 56px;
                    `,
                    css`
                        height: 310px;
                        margin-top: 56px;
                    `,
                    null,
                    null,
                ])}
        `,
    };
    return (
        <StyledWrapper {...bannerWrapper}>
            <StyledWrapper {...styles.imageWrapper}>
                <Img src={fields.image} altText={fields.name} loading="lazy" {...styles.img} />
            </StyledWrapper>
            <StyledWrapper {...styles.headingWrapper}>
                <Typography variant="h1" {...styles.heading}>
                    {translate("{0}",fields.name)}
                </Typography>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const CENLeadTemplateBanner: WidgetModule = {
    component: CENLeadBannerStyles,
    definition: {
        group: "Basic",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                name: fields.image,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Banner Image",
            },
            {
                name: fields.heading,
                displayName: "Name",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.backgroundImage,
                fieldType: "General",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                displayName: "Background Image",
            },
        ],
    },
};

export default CENLeadTemplateBanner;
